/* Copyright (C) Okahu Inc 2023-2024. All rights reserved. */
import { useLanguage } from '@/providers/LanguageProvider';

type KahuErrorResponseProps = {
  duration?: number;
  message: React.ReactNode;
};

export const KahuErrorResponse = ({
  message,
  duration,
}: KahuErrorResponseProps) => {
  const { messages } = useLanguage();

  return (
    <>
      <div className="relative w-fit break-words rounded-lg rounded-tl-none bg-[#F26C7466] py-2 pl-3 pr-4">
        <p className="text-body font-normal text-error-light">{message}</p>
        <span className="absolute right-full top-0 h-2 w-[6px] bg-[#F26C7466] [clip-path:polygon(0_0,100%_0,100%_100%)]"></span>
      </div>
      {/* response status and duration */}
      {duration != undefined && (
        <div className="mt-2 inline-flex items-center gap-4 text-[#8C9EA1]">
          <span className="text-body-sm text-form-input-disabled">
            {messages?.KahuAI?.stopped_by_error} • {duration}s
          </span>
        </div>
      )}
    </>
  );
};
